var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5H4.75C3.7835 13.5 3 12.7165 3 11.75V4.75C3 3.7835 3.7835 3 4.75 3H11.75C12.7165 3 13.5 3.7835 13.5 4.75V6.5M8.25 17H15.25C16.2165 17 17 16.2165 17 15.25V8.25C17 7.2835 16.2165 6.5 15.25 6.5H8.25C7.2835 6.5 6.5 7.2835 6.5 8.25V15.25C6.5 16.2165 7.2835 17 8.25 17Z",
    stroke: "#111827",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.35b1a1fd31fec575bee5ec952a708037.svg";
export { ForwardRef as ReactComponent };